import canvasElement from './canvasElement'
import BasicBox from '../helpers/BasicBox'
import BasicCircle from '../helpers/BasicCircle'
export default {
  components: {BasicBox, BasicCircle},
  mixins: [canvasElement],
  props: {
    width: {
      validator (value) {return !isNaN(value)},
      default: 100
    },
    height: {
      validator (value) {return !isNaN(value)},
      default: 100,
    },
    color: {
      type: String,
      default: 'black'
    },
    borderColor: {
      type: String,
      default: 'black'
    },
    borderDashed: Boolean,
    borderWidth: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    shapeRotation: {
      validator (value) {return !isNaN(value)},
    }
  },
  data () {
    return {}
  },
  computed: {
    shapeConfig () {
      const {height, width, color, transformerTargetName} = this.$props
      return {
        name: `${this.name}-shape`,
        baseName: this.name,
        height: parseFloat(height),
        width: parseFloat(width),
        fill: color,
        stroke: this.borderColor,
        dash: [8, 8],
        dashEnabled: !!this.borderDashed,
        strokeWidth: parseFloat(this.borderWidth),
        transformerTargetName,
        offset: {x: width / 2, y: height / 2},
      }
    }
  }
}